export default __webpack_public_path__ + "static/media/done.ac1bc754.svg";